module.exports = "/images/camera-line-top-right-bottom-left.svg?e376154bddccc18292c70b6c6ad8e295";